import { Component, OnInit } from '@angular/core';
import {Meta, Title} from "@angular/platform-browser";

@Component({
  selector: 'app-aslhome',
  templateUrl: './aslhome.component.html',
  styleUrls: ['./aslhome.component.scss']
})
export class AslhomeComponent implements OnInit {

  constructor(private meta: Meta,
              private titles: Title) { }

    ngOnInit(): void {
        window.scrollTo(0, 0);

        this.updateMetaTags();
    }

    updateMetaTags() {
        this.titles.setTitle('LLM Course at ARNI School of Law');
        this.meta.updateTag({
            name: 'description',
            content: `Pursue your LLM course at ARNI School of Law. Gain advanced legal knowledge and expertise for a successful career in law.`
        });
    }

}
